import { addDays, startOfDay } from 'date-fns';

const EXPIRY_TIME_IN_DAYS = 90;

export const isReleaseDateExpired = (releaseDate: number | Date, expiryTime: number = EXPIRY_TIME_IN_DAYS) => {
  const currentDate = startOfDay(new Date(Date.now()));

  const expiryDate = startOfDay(addDays(releaseDate, expiryTime));

  const currentDateUnixTimestamp = Math.floor(currentDate.getTime() / 1000);
  const expiryDateUnixTimestamp = Math.floor(expiryDate.getTime() / 1000);

  return expiryDateUnixTimestamp - currentDateUnixTimestamp > 0;
};
